<template>
  <svg
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66881 2.27614L1.93109 8.01387L0.988281 7.07107L6.72601 1.33333H1.66883V0H9.00214V7.33333H7.66881V2.27614Z"
      :fill="props.color"
    />
  </svg>
</template>
<script setup>
const props = defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
